import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js'
import { Chart, Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  ChartDataLabels,
  BarController,
)

function Graph({ datasets = [], labels = [], options = {}, className, width, height }) {
  return (
    <div className={className}>
      <Chart
        type="bar"
        data={{
          labels,
          datasets,
        }}
        options={options}
        width={width}
        height={height}
      />
    </div>
  )
}

Graph.Bar = ({ options, grahpData, width = 228, height = 135 }) => (
  <Bar options={options} data={grahpData} width={width} height={height} />
)

export default Graph
